import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
  })
export class OrganizationBasicValidator {

    ident_num = [
        Validators.required
    ];

    name = [
        Validators.required
    ];

    address = [
        Validators.required
    ];

    address_type = [
        Validators.required
    ];

    // Error messages
    errorMessages = {
        
        ident_num: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        address: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        address_type: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
    }
}